import React from 'react';
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Footer from "./Footer";
import "../styles/Policy.css";
import { Link } from "react-router-dom";

const TermsService = () => {
  return (
  <>
  <div className="terms-service">
    <Container>
      <Row className="justify-content-center">
        <Col md={10} lg={8}>
          <div className="terms-content mt-4 mb-5 p-4">
            <h1 className="text-center mb-4">Gebruiksvoorwaarden</h1>
            <p className="version-info text-center mb-4">
              Laatst bijgewerkt: 27 maart 2025
            </p>

            <p>Welkom bij Firgoquast. Door deze website en onze spellen te gebruiken, ga je akkoord met de volgende voorwaarden. Als je deze niet accepteert, maak dan geen gebruik van de dienst.</p>

            <h2>🎮 1. Over de dienst</h2>
            <ul>
              <li>Firgoquast biedt 100% gratis sociale casinospellen aan.</li>
              <li>Er is geen mogelijkheid om in te zetten, te kopen of echt geld of fysieke prijzen te winnen.</li>
              <li>Dit is geen online casino of kansspel volgens de Noorse wet.</li>
              <li>Alle spellen zijn uitsluitend ontwikkeld voor entertainment en hebben geen economische waarde.</li>
            </ul>

            <h2>🔞 2. Leeftijdsbeperking</h2>
            <ul>
              <li>De dienst is alleen bedoeld voor personen van 18 jaar of ouder.</li>
              <li>Door gebruik te maken van de website bevestig je dat je meerderjarig bent volgens de wetgeving van jouw land.</li>
            </ul>

            <h2>💳 3. Geen geld, geen aankopen</h2>
            <ul>
              <li>💸 Je kunt geen stortingen doen</li>
              <li>🛒 Er zijn geen betalingsmogelijkheden</li>
              <li>🎁 Je kunt geen echt geld of fysieke goederen winnen</li>
            </ul>
            <p>Firgoquast is volledig gratis te gebruiken, en er zijn geen functies die betrekking hebben op echt geld in enig deel van de dienst.</p>

            <h2>🧠 4. Verantwoord gebruik</h2>
            <p>We raden alle gebruikers aan om verantwoord en met mate te spelen.</p>
            <p>Als je problemen ervaart in verband met spelen, neem dan contact op met <a href="http://www.hjelpelinjen.no" target="_blank" rel="noopener noreferrer">www.hjelpelinjen.no</a> – een gratis en anonieme hulplijn in Noorwegen.</p>

            <h2>🔐 5. Privacy en cookies</h2>
            <p>We gebruiken cookies en verzamelen anonieme gebruiksgegevens om de dienst te verbeteren.</p>
            <p>Lees meer in onze <Link to="/personvernregler">Privacyverklaring.</Link></p>

            <h2>🔁 6. Wijzigingen in de voorwaarden</h2>
            <p>We kunnen de <Link to="/tjenestevilkår">voorwaarden</Link> bijwerken zonder voorafgaande kennisgeving. Door de website te blijven gebruiken, ga je akkoord met deze wijzigingen.</p>

            <h2>📬 7. Contact</h2>
            <p>Heb je vragen over deze voorwaarden? Neem contact met ons op:</p>
            <p>Firgoquast AS</p>
            <p>📍 Dronning Eufemias gate 16, 0191 Oslo, Noorwegen</p>
            <p>📧 E-mail: meister@gmail.com</p>
            <p>📞 Telefoon: +47 22 83 70 10</p>
          </div>
        </Col>
      </Row>
    </Container>
  </div>
  <Footer />
</>

  );
};

export default TermsService;
